class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    // 查找当前元素下的第一个 <details> 元素
    this.mainDetailsToggle = this.querySelector('details');
    
    if (!this.mainDetailsToggle) {
      console.error('No <details> element found.');
      return;
    }

    // 添加事件委托，将 focusout 事件委托给父元素
    this.parentElement.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut(event) {
    // 检查失去焦点的元素是否在当前 DetailsDisclosure 元素内部
    if (!this.contains(event.relatedTarget)) {
      // 如果不在内部，则调用 close 方法关闭 <details> 元素
      this.close();
    }
  }

  close() {
    // 移除 <details> 元素的 open 属性
    this.mainDetailsToggle.removeAttribute('open');
  }
}

// 定义 details-disclosure 自定义元素
customElements.define('details-disclosure', DetailsDisclosure);

